export { default as SectionFooter } from './SectionFooter';